/** The modest stand-in for a Save button: what the autosave is doing, nothing before the first edit. */
import { Tick } from '@/components/icons';
import type { SaveState } from '@/hooks/use-autosave';

export function SaveStatus({ state, error }: { state: SaveState; error?: string | null }) {
  return (
    <span className={`save-status ${state}`} role="status" aria-live="polite" title={state === 'error' ? error ?? undefined : undefined}>
      {state === 'saving' && 'Saving…'}
      {state === 'saved' && <><Tick />Saved</>}
      {state === 'error' && 'Not saved'}
    </span>
  );
}
